const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};

/* ------------------------------------------------------------------
 * VELNA - BUNDLE & SAVE: real saving amount
 * Rewrites the "You save ..." caption of every bundle option to the
 * actual money saved = compare-at total minus the bundle price shown
 * on the same row. Derived from the rendered prices, so it stays
 * correct when the price, the compare-at price, the quantity or the
 * discount percentage changes, and after a variant switch.
 * No-op on pages without a BUNDLE & SAVE widget.
 * ------------------------------------------------------------------ */
(function () {
  function parts(text) {
    var m = (text || '').match(/([^\d]*)([\d.,]+)([^\d]*)/);
    if (!m) return null;
    var raw = m[2];
    var dec = /,\d{2}$/.test(raw) ? ',' : '.';
    var n = dec === ','
      ? parseFloat(raw.replace(/\./g, '').replace(',', '.'))
      : parseFloat(raw.replace(/,/g, ''));
    if (isNaN(n)) return null;
    return { pre: m[1], post: m[3], value: n, dec: dec };
  }

  function fmt(n, ref) {
    var s = n.toFixed(2);
    var whole = s.split('.')[0];
    var frac = s.split('.')[1];
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ref.dec === ',' ? '.' : ',');
    return ref.pre + whole + ref.dec + frac + ref.post;
  }

  function apply() {
    var rows = document.querySelectorAll('.quantity-break');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var cap = row.querySelector('.quantity-break__caption');
      if (!cap) continue;

      var priceEl = row.querySelector('.quantity-break__price');
      var compareEl = row.querySelector('.quantity-break__compare-price');
      var deal = parts(priceEl ? priceEl.textContent : '');
      if (!deal) continue;
      var compare = parts(compareEl ? compareEl.textContent : '');

      var save = (compare ? compare.value : deal.value) - deal.value;

      if (save <= 0.004) {
        if (cap.style.display !== 'none') cap.style.display = 'none';
        continue;
      }
      if (cap.style.display === 'none') cap.style.display = '';

      var out = fmt(save, compare || deal);
      var span = cap.querySelector('span');
      if (span) {
        if (span.textContent.trim() !== out) span.textContent = out;
      } else {
        var next = cap.textContent.replace(/[\d][\d.,]*\s*%|[^\s]*[\d][\d.,]*/, out);
        if (next === cap.textContent) next = cap.textContent.replace(/\[[^\]]*\]/, out);
        if (cap.textContent.trim() !== next.trim()) cap.textContent = next;
      }
    }
  }

  function boot() {
    apply();
    var box = document.querySelector('.quantity-breaks-container');
    if (box && window.MutationObserver) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(apply, 40);
      }).observe(box, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
